import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

import '../css/WhyNexuniSection.css';

class WhyNexuniSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      hasAnimated: false,
      sectionTitle: {
        "zh": "為什麼選擇 NEXUNI",
        "en": "Why NEXUNI",
        "ja": "NEXUNIを選ぶ理由"
      },
      stats: [
        {
          value: 100,
          suffix: "+",
          label: {
            "zh": "機器人與自動化系統已部署",
            "en": "Robots & Automation Systems Deployed",
            "ja": "ロボット＆自動化システム導入済み"
          }
        },
        {
          value: 88,
          suffix: "%",
          label: {
            "zh": "五年人力成本節省",
            "en": "5-Year Labor Cost Savings",
            "ja": "5年間の人件費削減"
          }
        },
        {
          value: 150,
          suffix: "%",
          label: {
            "zh": "生產力提升",
            "en": "Productivity Boost",
            "ja": "生産性向上"
          }
        }
      ],
      cards: [
        {
          title: {
            "zh": "降低人力依賴",
            "en": "Reduce Labor Dependency",
            "ja": "人材依存の低減"
          },
          desc: {
            "zh": "透過 AI 驅動的自動化，降低對專業人力的依賴",
            "en": "Lower reliance on skilled labor with AI-driven automation",
            "ja": "AI駆動の自動化により、熟練労働者への依存を低減"
          }
        },
        {
          title: {
            "zh": "快速回本",
            "en": "Fast ROI",
            "ja": "迅速な投資回収"
          },
          desc: {
            "zh": "投資回收期在六個月內",
            "en": "Return on investment in under 6 months",
            "ja": "6ヶ月以内の投資回収"
          }
        },
        {
          title: {
            "zh": "實績驗證",
            "en": "Proven Deployments",
            "ja": "実証済みの導入実績"
          },
          desc: {
            "zh": "超過 100 套機器人與自動化系統在實際場域運行",
            "en": "100+ robots and automation systems operating in real-world sites",
            "ja": "100以上のロボット＆自動化システムが実環境で稼働中"
          }
        }
      ],
    };

    this.statsRef = React.createRef();
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.state.hasAnimated) {
            this.setState({ hasAnimated: true });
            this.animateAllCounters();
            this.observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );

    if (this.statsRef.current) {
      this.observer.observe(this.statsRef.current);
    }
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  animateAllCounters() {
    this.state.stats.forEach((stat, index) => {
      this.animateCounter(index);
    });
  }

  animateCounter(index) {
    const stat = this.state.stats[index];
    const el = document.getElementById('why-stat-' + index);
    if (!el) return;
    const target = stat.value;
    el.textContent = '0';
    let startTimestamp = null;
    const duration = target > 100 ? 1500 : 1000;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = target;
      }
    };
    window.requestAnimationFrame(step);
  }

  handleStatHover(index) {
    this.animateCounter(index);
  }

  render() {
    const lang = this.state.lang;

    return (
      <div className="why-nexuni-section">
        <div className="why-nexuni-inner">
          <Fade duration={800} delay={200}>
            <h2 className="why-nexuni-title">{this.state.sectionTitle[lang]}</h2>
          </Fade>

          {/* Stats row */}
          <div className="why-nexuni-stats" ref={this.statsRef}>
            {this.state.stats.map((stat, index) => (
              <Fade duration={800} delay={300 + index * 100} key={index}>
                <div className="why-nexuni-stat" onMouseEnter={() => this.handleStatHover(index)}>
                  <div className="why-nexuni-stat-value">
                    <span id={'why-stat-' + index}>0</span>
                    <span className="why-nexuni-stat-suffix">{stat.suffix}</span>
                  </div>
                  <p className="why-nexuni-stat-label">{stat.label[lang]}</p>
                </div>
              </Fade>
            ))}
          </div>

          {/* Key message cards */}
          <div className="why-nexuni-cards">
            {this.state.cards.map((card, index) => (
              <Fade duration={800} delay={400 + index * 150} key={index}>
                <div className="why-nexuni-card">
                  <div className="why-nexuni-card-accent"></div>
                  <h3>{card.title[lang]}</h3>
                  <p>{card.desc[lang]}</p>
                </div>
              </Fade>
            ))}
          </div>

        </div>
      </div>
    );
  }
}

export default WhyNexuniSection;
